<nav class="side-menu" aria-label="Navegación principal">
  @for (section of sections; track section.caption ?? $index) {
    <div class="side-menu__group">
      @if (section.caption) {
        @if (rail()) {
          <span class="side-menu__divider" role="presentation"></span>
        } @else {
          <p class="menu-caption" [id]="'ks-menu-caption-' + $index">{{ section.caption }}</p>
        }
      }

      <ul
        class="side-menu__list"
        [attr.aria-labelledby]="section.caption && !rail() ? 'ks-menu-caption-' + $index : null">
        @for (item of section.items; track item.label) {
          <li>
            <app-menu-item [item]="item" [rail]="rail()" (navigated)="navigated.emit()" />
          </li>
        }
      </ul>
    </div>
  }
</nav>
